import StoreCart from './components/cart/StoreCart/StoreCart';

const OrderNew = ({ userData, setActiveStep, activeStep, partner, initValue }) => {
    return (
        <StoreCart
            activeStep={activeStep}
            userData={userData}
            partner={partner}
            setActiveStep={setActiveStep}
            initValue={initValue}
        />
    );
};

export default OrderNew;
